import jimp from 'jimp'

const is = require('./is')

/**
 * @param {*} inputField
 * @param {*} containerInput
 * @param {*} spinner
 * @param {*} button
 */
export const asyncHandleFileSelected = async (inputField, containerInput, spinner, button) => {
  const files = inputField.files
  if (files.length === 0) {
    return null
  }

  const imageFile = files[0]
  if (is.file(imageFile) && ['png', 'jpg', 'jpeg'].indexOf(is.getFileName(inputField.value, '.')) === -1) {
    return imageFile
  }

  button.disabled = true
  spinner.style.display = 'flex'
  if (containerInput) {
    containerInput.style.display = 'none'
    inputField.nextElementSibling.innerHTML = files[0].name
    spinner.style.display = 'block'
  }

  const resultJimp = await jimp.read(URL.createObjectURL(imageFile)).catch(() => {
    if (containerInput) {
      containerInput.style.display = 'block'
    }
    spinner.style.display = 'none'
    button.disabled = false
  })
  if (!is.checkVariable(resultJimp)) {
    return null
  }

  resultJimp.scaleToFit(1000, 1000)
  resultJimp.quality(100)

  const data = await resultJimp.getBufferAsync(imageFile.type)
  if (containerInput) {
    containerInput.style.display = 'block'
  }
  spinner.style.display = 'none'
  button.disabled = false

  return new File([data], '1000x1000', { type: imageFile.type })
}
